import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

//- material ui
import { withStyles } from '@material-ui/core/styles';
import Paper from "@material-ui/core/Paper";
import Grid from '@material-ui/core/Grid';
//import Button from "@material-ui/core/Button";
//import Zoom from "@material-ui/core/Zoom";

//- local ui
import { getGlobalClasses } from '../../themes';
import {post} from "../../modules/utility";
import AuthUserContainer from "../../containers/AuthUser";
import FormComponent from "../../components/FormComponent";
//import FormSelect from "../../components/form/FormSelect";
//import FormTextArea from "../../components/form/FormTextArea";

//- icons / images
//import CircularProgress from "@material-ui/core/CircularProgress";
import GreenChecked from "../../images/icons/greenChecked.svg";
import WarningIconSvg from "../../images/icons/warningIcon.svg";
import Note from "../../components/Note";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		submitButton : {
			marginTop : 30,
			fontSize : 16,
			borderRadius : '100px',
			padding : '12px 40px',
			textTransform: 'uppercase',
			marginRight : 10,
			lineHeight : '20px',
			height : 70,
		},
		greenCheckedIcon : {
			display: 'inline-block',
			width: 33,
			height: 33,
			backgroundImage: `url('${GreenChecked}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight : 2,
			marginLeft : 5,
		},
		isSaving : {
			marginLeft : 20,
			fontSize : 16,
			color : '#1565C0',
		},
		savingSuccessful : {
			marginLeft : 20,
			fontSize : 16,
			color : '#2E7D32',
		},
		smallWarningIcon : {
			display: 'inline-block',
			width: 28,
			height: 28,
			backgroundImage: `url('${WarningIconSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight : 0,
			marginLeft : 0,
			marginTop : -6,
		},
		warningContainer : {
			borderRadius : 5,
			border : '1px solid #ccc',
			padding : 20,
			marginTop : 10,
			marginBottom : 10,
		},

		//-----

		xContainer : {
			marginTop : 20,
			marginBottom : 50,
		},
		xLabel : {
			fontSize : 20,
			fontWeight: 600,
		},
		xDescription : {
			marginTop : 5,
		},
		xConditions : {
			margin : '17px 0px 2px 0px',
			textAlign : 'left',
			textTransform : 'uppercase',
			fontSize : 14,
			color : '#666',
			fontWeight : 900,
			letterSpacing : 2,
		},
		conditionContainer : {
			marginLeft : 0,
		},
		ruleContainer : {
			border : '1px solid #ccc',
			borderRadius : '2px',
			padding : 20,
		},
		orSpacer : {
			margin : '3px 0px',
			color : '#666',
			fontStyle : 'italic',
		},
		hasLineItem : {
			margin : '12px 0px 0px 0px',
			textTransform : 'uppercase',
			fontSize : 13,
			color : '#555',
			//fontWeight : 00,
			letterSpacing : 2,
			marginLeft : 5,
		},
		detailRuleContainer : {
			paddingLeft : 10,
			margin : '5px 5px 5px 5px',
			borderLeft : '2px solid #ddd',
		},

		runningSearch : {
			paddingLeft : 20,
			display : 'flex',
			alignItems : 'center',
			fontSize : 18,
			color :  '#666',
		},
		totalStats : {
			fontSize : 18,
			paddingLeft : 10,
			margin : '10px 0',
		},
		totalMatched : {
			fontSize : 24,
			paddingLeft : 10,
			margin : '10px 0',
			marginTop : 30,
			borderBottom : `1px solid #eee`,
		},
		matchContainer : {
			//borderLeft : '2px solid #ccc',
			paddingLeft : 20,
			marginTop : 20,
		},
		tmwId : {
			fontWeight : 600,
		}
	};
};



class InvoiceAudit extends FormComponent {

	constructor(props) {
		super(props);
		this.state = {
		};
	}

	componentDidMount() {
		const { showErrors } = this.props;
		post({
			method: 'invoiceAudit.conditions.search',
			params: {},
			callback: (err, r) => {
				if (err) {
					showErrors(err);
					return;
				}
				const exceptionChecks = _.get(r, 'exceptionChecks');
				this.setState({ exceptionChecks });
			}
		});
	}

	runAudit = () => {
		const { showErrors } = this.props;
		this.setState({ isRunningAudit : true });
		post({
			method: 'invoiceAudit.run',
			params: {},
			callback: (err, r) => {
				this.setState({ isRunningAudit : false });
				if (err) {
					showErrors(err);
					return;
				}
				const auditRunResults = r;
				this.setState({ auditRunResults });
			}
		});


	};

	renderAuditRunResults = () => {
		const { classes } = this.props;
		const { auditRunResults } = this.state;

		if (!auditRunResults) {
			return null;
		}

		const {
			totalInvoicesChecked,
			totalExceptionsChecked,
			totalRulesProcessed,
			matchedExceptions,
		} =  auditRunResults;

		return (
			<Paper className={classes.globalMainPaper}>
				<div className={classes.globalMainHeadline}>Audit Results</div>
				<Grid spacing={2} container>
					<Grid item xs={12} sm={12} md={10}>
						<div>
							<div className={classes.totalStats}>
								<div>Total Invoices Checked : {totalInvoicesChecked}</div>
								<div>Total Exceptions Processed : {totalExceptionsChecked}</div>
								<div>Total Rules Processed Checked : {totalRulesProcessed}</div>
							</div>
							<div>
								{_.isEmpty(matchedExceptions) && <div>Zero exceptions matched</div>}
								{!_.isEmpty(matchedExceptions) && this.renderMatchedExceptions({ matchedExceptions }) }
							</div>
						</div>
					</Grid>
				</Grid>
			</Paper>
		);
	};

	renderMatchedExceptions = ({ matchedExceptions }) => {
		const { classes } = this.props;
		console.log("CALLING", matchedExceptions);
		return (
			<div>
				<div className={classes.totalMatched}>{matchedExceptions.length} Exceptions Matched</div>

				{matchedExceptions.map(matchedException => {
					const {tmwInvoice, exceptionCheck, allMatchReasons} = matchedException;
					return (<div className={classes.xContainer}>
						<div className={classes.xLabel}><span className={classes.smallWarningIcon}/> {exceptionCheck.label}</div>
						<div className={classes.xDescription}>{exceptionCheck.description}</div>

						<div className={classes.matchContainer}>
							<div>TMW Invoice Id: <span className={classes.tmwId}>{tmwInvoice.tmwInvoiceId}</span></div>
							<div>TMW Order Id: <span className={classes.tmwId}>{tmwInvoice.tmwOrderId}</span></div>
							<div>Invoice Number: <span className={classes.tmwId}>{tmwInvoice.invoiceNumber}</span></div>
							<div>Last Updated By: <span className={classes.tmwId}>{tmwInvoice.lastUpdatedBy}</span></div>
							<div>Bill To: <span className={classes.tmwId}>
								{tmwInvoice.formattedBillToCompany} ({tmwInvoice.billTo})
							</span></div>
							<div>Delivery Date: <span className={classes.tmwId}>
								{moment(tmwInvoice.deliveryDate).format('dddd, M/D [@] h:mm a')}
							</span></div>
							<div>Driver (Truck):
								<span className={classes.tmwId}>{tmwInvoice.driverName} ({tmwInvoice.truckName})</span>
							</div>

							<div className={classes.xConditions}>Match Reasons</div>
							<div className={classes.ruleContainer}>
								{allMatchReasons.map((reason, i) => (
									<div>{(i >= 1) ? (<span style={{fontWeight: 500}}>and </span>) : ''} {reason}</div>
								))}
							</div>
						</div>
					</div>);
				})}
			</div>
		);
	};

	render() {
		const {
			classes,

		} = this.props;

		const {
			exceptionChecks,
			isRunningAudit,
		} = this.state;


		if (_.isEmpty(exceptionChecks)) {
			return (<div className={classes.fetching}>Fetching exception checks...</div>);
		}

		return (<>
			<Paper className={classes.globalMainPaper}>
				<div className={classes.globalMainHeadline}>Run Invoice Audit</div>
				<Grid spacing={2} container>
					<Grid item xs={12} sm={12} md={10}>
						<Note label={`
							Invoice audits are automatically run every 10 minutes and any exceptions that trigger are
							emailed to er@stlwest.com. Below you can run the audit manually if you want to see the
							results on this web page.
						`} />
					</Grid>

					<Grid item xs={12} style={{padding : '20px 0px', display : 'flex'}}>
						<div style={{display : 'flex'}}>
							<Button
								onClick={this.runAudit}
								variant="contained"
								color="primary"
								className={classes.submitButton}
							>
								Run Full Audit Manually
							</Button>


							{isRunningAudit &&
							<div className={classes.runningSearch}>
								<CircularProgress/>
								<span style={{paddingLeft: 10}}>Searching...</span>
							</div>
							}
						</div>


					</Grid>
				</Grid>
			</Paper>

			{this.renderAuditRunResults()}

			<Paper className={classes.globalMainPaper}>
				<div className={classes.globalMainHeadline}>Exception Checks</div>
				<Grid spacing={2} container>
					<Grid item xs={12} sm={12} md={10}>

						{exceptionChecks.map((exceptionCheck, xIndex) => {
							const { label, description, conditions} = exceptionCheck;
							return (
								<div className={classes.xContainer} key={`x_${xIndex}`}>
									<div className={classes.xLabel}>{label}</div>
									<div className={classes.xDescription}>{description}</div>
									<div className={classes.xConditions}>Conditions</div>

									{conditions.map((condition, i) => {
										const { invoiceRules, detailRules }  = condition;

										let andHasLineItem;
										if (!_.isEmpty(detailRules)) {
											if (!_.isEmpty(invoiceRules)) {
												andHasLineItem = `and has an item that matches`;
											} else {
												andHasLineItem = `Has an item that matches`;
											}
										}

										return (
											<div key={`condition_${i}`} className={classes.conditionContainer}>
												{i >= 1 && <div className={classes.orSpacer}>
													- or -
												</div>}
												<div className={classes.ruleContainer}>
													{invoiceRules && <div>
														{invoiceRules.map(this.renderRule)}
													</div>
													}

													{andHasLineItem && <div className={classes.hasLineItem}>
														{andHasLineItem}
													</div>}

													{detailRules && <div className={classes.detailRuleContainer}>
														{detailRules.map(this.renderRule)}
													</div>
													}

												</div>
											</div>
										);
									})}
								</div>
							);
						})}
					</Grid>
				</Grid>
			</Paper>
		</>);
	}

	renderRule = (rule, i) => {
		const { field, operation, value, params } = rule;
		const and = (i >= 1) ? (<span style={{fontWeight: 500}}>and </span>) : '';

		let valueDisplay = value;
		if (_.isArray(value)) {
			valueDisplay = ` : ` + value.join(', ');
		} else if (_.isObject(value)) {
			valueDisplay = ` : ` + _gs(value);
		}

		if (operation === 'tallyIsGreaterThan') {
			const { tallyCount, property, propertyValuesToIgnore } = rule.params;
			return (
					<div key={`rule_${i}`}>
						{and}{_.startCase(field)} has any {_.startCase(property)} that shows up
						more than {(tallyCount === 1) ? ' once ' : ` ${tallyCount} times `}
						on the same invoice while ignoring {propertyValuesToIgnore.join(', ')}.
					</div>
				)
		} else if (operation === 'duplicateValues') {
			const {properties} = params;
			return `${_.startCase(field)} has duplicate values for ${properties.join(', ')}`;
		} else if (operation === 'propertyIsNull') {
			const {property} = params;
			return `${_.startCase(field)} has a property : ${_.startCase(property)}, that is empty.`;
		} else if (operation === 'isNull') {
			return (
				<div key={`rule_${i}`}>
					{and}{_.startCase(field)} is empty.
				</div>
			);
		} else {
			return (
				<div key={`rule_${i}`}>
					{and}{_.startCase(field)} {_.startCase(operation)} {valueDisplay}.
				</div>
			);
		}
	}
}

function _gs(obj) {
	let printValues = '';
	_.keys(obj).forEach(field => {
		printValues += `${field} : ${obj[field]}`;
	});
	return printValues;
}

InvoiceAudit.propTypes = {
	classes: PropTypes.object.isRequired,
	authUser : PropTypes.object,
};

export default _.flow([
	withStyles(styles),
	AuthUserContainer,
])(InvoiceAudit);
